import { DriverPreviousLicenceCheckDates } from "../../../../models/api/admin/driver";
import { StatusAction } from "../../../ActionableStatus/ActionableStatus";
import { LicenceChecksActions } from "../licenceCheckActions";
import LicenceCheckStatus from "../LicenceCheckStatus";

type CheckedLicenceCheckStatusProps = {
    driverId: string;
    previousLicenceCheckDates: DriverPreviousLicenceCheckDates;
    isManual: boolean;
    lastCheckDate: string;
    nextCheckDate: string;
    buildActions: (actionNames: LicenceChecksActions[]) => StatusAction[];
};

const CheckedLicenceCheckStatus = ({
    driverId,
    isManual,
    lastCheckDate,
    nextCheckDate,
    buildActions,
    previousLicenceCheckDates,
}: CheckedLicenceCheckStatusProps) => {
    const actions = buildActions(
        isManual
            ? [
                  "editCheckDate",
                  "markAsPending",
                  "markAsFailed",
                  "disableFurtherChecks",
                  "changeToAutomatic",
                  "previousLicenceCheckDates",
              ]
            : [
                  "editCheckDate",
                  "retryCheck",
                  "changeToManual",
                  "disableFurtherChecks",
                  "previousLicenceCheckDates",
              ]
    );

    return (
        <LicenceCheckStatus
            previousLicenceCheckDates={previousLicenceCheckDates}
            actions={actions}
            theme="completed"
            text="Checked"
            driverId={driverId}
            isManual={isManual}
        >
            <span>Last check: {lastCheckDate}</span>
            <span>Next check: {nextCheckDate}</span>
        </LicenceCheckStatus>
    );
};

export default CheckedLicenceCheckStatus;
